export default function millisecondsToDateString(milliseconds:number):string{
    let date = new Date(milliseconds);
    
    var year = date.getFullYear();

    return `${formatDay(date)}/${formatMonth(date)}/${year}`
}

export function millisecondsToDateStringAndHours(milliseconds:number):string{
    let date = new Date(milliseconds);
    
    var year = date.getFullYear();

    return `${formatDay(date)}/${formatMonth(date)}/${year} às ${formatHours(date)}:${formatMinutes(date)}`
}

function formatDay(date:Date):string{
    let dayStr:string = '';
    let day = date.getDate();
    if(day <=9){
        return dayStr = "0"+day.toString();
    }
    return day.toString();
}

function formatMonth(date:Date):string{
    let monthStr:string = '';
    let month = 1 + date.getMonth();
    if(month <=9){
        return monthStr = "0"+month.toString();
    }
    return (month).toString();
}

function formatHours(date:Date):string{
    let hourStr:string = ''
    let hour = date.getHours();
    if(hour <=9){
        return hourStr = "0"+hour.toString();
    }
    return (hour).toString();
}

function formatMinutes(date:Date):string{
    let minutesStr:string = ''
    let minutes = date.getMinutes();
    if(minutes <=9){
        return minutesStr = "0"+minutes.toString();
    }
    return (minutes).toString();
}